export const ages = [
  { id: '0', label: '10歳未満', value: '0' },
  { id: '1', label: '10代', value: '1' },
  { id: '2', label: '20代', value: '2' },
  { id: '3', label: '30代', value: '3' },
  { id: '4', label: '40代', value: '4' },
  { id: '5', label: '50代', value: '5' },
  { id: '6', label: '60代', value: '6' },
  { id: '7', label: '70代', value: '7' },
  { id: '8', label: '80代以上', value: '8' },
];
